module.exports = __webpack_public_path__ + "static/img/tabela.3b456f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/oitosegundos/tabela.png
// module id = p051
// module chunks = 0